import api from './api'

export interface TikTokAuthResponse {
  access_token: string
  refresh_token: string
  expires_in: number
  scope: string
}

export interface TikTokUserInfo {
  id: string
  display_name: string
  avatar_url: string
}

export interface TikTokVideoUploadRequest {
  video_file: File
  title: string
  privacy_level?: 'PUBLIC_TO_EVERYONE' | 'MUTUAL_FOLLOW_FRIENDS' | 'SELF_ONLY'
}

export interface TikTokVideoUploadResponse {
  video_id: string
  status: string
  create_time: number
}

// TikTok OAuth 토큰 교환
export const exchangeTikTokCode = async (
  code: string
): Promise<TikTokAuthResponse> => {
  const response = await api.post('/api/tiktok/auth/callback', { code })
  return response.data
}

// TikTok 사용자 정보 조회
export const getTikTokUserInfo = async (): Promise<TikTokUserInfo> => {
  const response = await api.get('/api/tiktok/user/info')
  return response.data
}

// TikTok 비디오 업로드
export const uploadVideoToTikTok = async (
  data: TikTokVideoUploadRequest
): Promise<TikTokVideoUploadResponse> => {
  const formData = new FormData()
  formData.append('video', data.video_file)
  formData.append('title', data.title)
  if (data.privacy_level) {
    formData.append('privacy_level', data.privacy_level)
  }

  const response = await api.post('/api/tiktok/video/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

// TikTok 액세스 토큰 저장
export const saveTikTokToken = (token: string) => {
  localStorage.setItem('tiktok_access_token', token)
}

// TikTok 액세스 토큰 가져오기
export const getTikTokToken = () => {
  return localStorage.getItem('tiktok_access_token')
}

// TikTok 액세스 토큰 삭제
export const removeTikTokToken = () => {
  localStorage.removeItem('tiktok_access_token')
}

// TikTok 로그인 상태 확인
export const isTikTokLoggedIn = () => {
  return !!getTikTokToken()
}
